import { Controller } from "@hotwired/stimulus"

// Minimal rich-text: toolbar buttons run execCommand on the contenteditable
// target and dispatch `input` so the resume-editor autosave fires. Output is
// sanitized server-side against Resume::ALLOWED_HTML_TAGS.
export default class extends Controller {
  static targets = ["editable"]

  bold()    { this.exec("bold") }
  italic()  { this.exec("italic") }
  bullets() { this.exec("insertUnorderedList") }
  link()    { const url = window.prompt("Link URL (https://…)"); if (url) this.exec("createLink", url) }

  exec(cmd, val = null) {
    this.editableTarget.focus()
    document.execCommand(cmd, false, val)
    this.editableTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
